import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Theme } from '../generated/openapi/befunde-api';

export interface ThemeState {
  theme: Theme;
  previewMode: boolean;
  setTheme: (theme: Theme, previewMode: boolean) => void;
}

export const defaultTheme: Theme = {
  id: 'default',
  name: 'Default Theme',
  colorPrimary: '#0d9488',
  controlItemBgActive: '#f0fdfa',
  controlItemBgActiveHover: '#ddf5f0',
  logoData: '',
};

export const useThemeStore = create<ThemeState>()(
  devtools(
    set => ({
      theme: defaultTheme,
      previewMode: false,
      setTheme: (theme, previewMode) => set({ theme, previewMode }),
    }),
    { name: 'theme-store' }
  )
);
